import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { useTheme } from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ResponsiveCardGridContainer from '../ResponsiveCardGridContainer';
import ContentCardSkeleton from '../TrackCard/ContentCardSkeleton';
import ApiError from '../Errors/ApiError';
import { SkeletonBlock } from '../Skeleton';
import SectionHeading from '../SectionHeading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendationsSkeleton = ({
  error
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "recommendations-skeleton",
    marginBlockStart: isMobile ? '500' : '900',
    children: [/*#__PURE__*/_jsx(SectionHeading, {
      subText: /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          height: theme.space['400'],
          width: "30%"
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.headers.recommended"
      })
    }), error ? /*#__PURE__*/_jsx(ApiError, {
      error: error
    }) : /*#__PURE__*/_jsxs(ResponsiveCardGridContainer, {
      columnSize: 250,
      columns: 3,
      maxInlineSize: 405,
      nowrap: true,
      children: [/*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {})]
    })]
  });
};
export default RecommendationsSkeleton;